<template>
  <div v-if="selectedProduct">
    <ProductShow :product="selectedProduct" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ProductShow from "@/components/Products/ProductShow";
export default {
  data(){
    return {
      expired: false
    }
  },
  components: {
    ProductShow
  },
  computed: {
    ...mapState("products", ["selectedProduct"])
  },
  methods: {
    ...mapActions("products", ["fetchProduct"])
  },
  mounted() {
    let params = this.$route.params;
    if (params.myProduct) {
      this.fetchProduct({id: params.id, myProduct: "true"});
    } else{
      this.fetchProduct({id: params.id, myProduct: "false"});
    }
  }
};
</script>

<style>
.control-box .thumb-list {
  display: flex !important;
}
.control {
  display: block !important;
}
</style>
